module.exports = __webpack_public_path__ + "static/img/qs_wf.e4377d72.png";